var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgToDo = function SvgToDo(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16.449 20.937",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 6172"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 6171"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.356 2.743h-1.893V1.9c0-.274-.3-.4-.573-.4h-1.47A2.23 2.23 0 0 0 8.2 0a2.27 2.27 0 0 0-2.218 1.5H4.536c-.274 0-.548.125-.548.4v.847H2.094A2.12 2.12 0 0 0 0 4.766v14.277a2.005 2.005 0 0 0 2.094 1.894h12.262a2.005 2.005 0 0 0 2.094-1.894V4.762a2.12 2.12 0 0 0-2.094-2.019m-9.371-.249h1.371a.55.55 0 0 0 .474-.449A1.446 1.446 0 0 1 8.2.924a1.42 1.42 0 0 1 1.346 1.122.55.55 0 0 0 .5.449h1.417v1.993h-6.48Zm10.468 16.549a1.01 1.01 0 0 1-1.1.9H2.094a1.01 1.01 0 0 1-1.1-.9V4.762a1.12 1.12 0 0 1 1.1-1.022h1.894v1.271a.523.523 0 0 0 .548.474h7.352a.55.55 0 0 0 .573-.474V3.74h1.894a1.12 1.12 0 0 1 1.1 1.022v14.281Z",
    "data-name": "Pfad 1315"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.305 11.143a.5.5 0 0 0-.7-.025l-1.6 1.52-.673-.7a.5.5 0 0 0-.7-.025.523.523 0 0 0 0 .723l1.022 1.047a.45.45 0 0 0 .349.15.5.5 0 0 0 .349-.15l1.944-1.844a.473.473 0 0 0 .029-.669Z",
    "data-name": "Pfad 1316"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.459 12.214H7.727a.5.5 0 0 0 0 1h5.732a.5.5 0 0 0 0-1",
    "data-name": "Pfad 1317"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.305 7.155a.5.5 0 0 0-.7-.025l-1.6 1.52-.673-.7a.5.5 0 0 0-.7-.025.523.523 0 0 0 0 .723l1.022 1.047a.45.45 0 0 0 .349.15.5.5 0 0 0 .349-.15l1.944-1.844a.473.473 0 0 0 .029-.669Z",
    "data-name": "Pfad 1318"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.459 8.226H7.727a.5.5 0 0 0 0 1h5.732a.5.5 0 1 0 0-1",
    "data-name": "Pfad 1319"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.305 15.13a.5.5 0 0 0-.7-.025l-1.6 1.52-.673-.7a.5.5 0 0 0-.7-.025.523.523 0 0 0 0 .723l1.022 1.047a.45.45 0 0 0 .349.15.5.5 0 0 0 .349-.15l1.944-1.844a.473.473 0 0 0 .029-.669Z",
    "data-name": "Pfad 1320"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.459 16.202H7.727a.5.5 0 1 0 0 1h5.732a.5.5 0 1 0 0-1",
    "data-name": "Pfad 1321"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgToDo);
export default ForwardRef;